import {Component, OnInit} from '@angular/core';
import {InvoiceProcessingService} from '~/app/core/services/invoice-processing.service';
import {FormControl, FormGroup} from '@angular/forms';
import {DialogRef} from '@progress/kendo-angular-dialog';

@Component({
  selector: 'app-export-dialog',
  templateUrl: './export-dialog.component.html',
  styleUrls: ['./export-dialog.component.scss']
})
export class ExportDialogComponent implements OnInit {
  formGroup: FormGroup;
  public checked = false;


  constructor(public invoiceProcessingService: InvoiceProcessingService,
              private dialogRef: DialogRef) {
  }

  ngOnInit() {
    this.buildForm();
  }

  buildForm() {
    let group = {};
    this.invoiceProcessingService.downloadTypes.forEach(type => {
      group[type] = new FormControl(true);
    });
    this.formGroup = new FormGroup(group);
  }

  onSubmit() {
    console.log(this.formGroup.value);
    let data = this.formGroup.value;
    let output = {
      ...data
    };
    this.dialogRef.close({text: 'Submit', primary: true, output});
  }
}
